import { useState, useEffect, useEffectEvent } from "react";
import { cleanFilters } from "@/helpers/cleanFilters";
import axios, { AxiosError } from "axios";
import { api } from "@/services/api";
import { ApiSelect } from "@/types/apiSelect";

export interface ApiSelectOptions {
  realPath?: boolean;
}

export function useApiFetchSelect({
  endpoint,
  filters,
  options,
}: {
  endpoint?: string;
  filters?: object;
  options?: ApiSelectOptions;
}) {
  const [data, setData] = useState<ApiSelect[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<AxiosError | Error | null>(null);

  const fetchData = useEffectEvent(async () => {
    if (!endpoint) return;
    setLoading(true);
    setError(null);
    try {
      const path = `/${endpoint}${options?.realPath === true ? "" : "/select"}`;

      const response = await api.get<ApiSelect[]>(path, {
        params: cleanFilters(filters ?? {}),
      });

      setData(response.data);
    } catch (e) {
      if (axios.isAxiosError(e)) setError(e);
      else setError(new Error("Unexpected error"));
      setData([]);
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint, filters, options?.realPath]);

  return { data, loading, error, refetch: fetchData };
}
